/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Description_Length_HelpInputs */

const en_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how long each generated description should be.`)
};

const fr_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez la longueur de chaque description générée.`)
};

const de_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Länge der einzelnen generierten Beschreibungen.`)
};

const it_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli la lunghezza di ciascuna descrizione generata.`)
};

const ru_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите длину каждого сгенерированного описания.`)
};

const es_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige la longitud que debe tener cada descripción generada.`)
};

const zh_cn2_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择每条生成的描述的长度。`)
};

const ja_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成される各説明文の長さを選択してください。`)
};

const hi_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रत्येक जनरेट किए गए विवरण की लंबाई चुनें।`)
};

const pt_pt2_ad_description_length_help = /** @type {(inputs: Ad_Description_Length_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha o tamanho desejado para cada descrição gerada.`)
};

/**
* | output |
* | --- |
* | "Choose how long each generated description should be." |
*
* @param {Ad_Description_Length_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_description_length_help = /** @type {((inputs?: Ad_Description_Length_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Description_Length_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_description_length_help(inputs)
	if (locale === "de") return de_ad_description_length_help(inputs)
	if (locale === "it") return it_ad_description_length_help(inputs)
	if (locale === "ru") return ru_ad_description_length_help(inputs)
	if (locale === "es") return es_ad_description_length_help(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_description_length_help(inputs)
	if (locale === "ja") return ja_ad_description_length_help(inputs)
	if (locale === "hi") return hi_ad_description_length_help(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_description_length_help(inputs)
	return en_ad_description_length_help(inputs)
});